import sidebar_menu from "./templates/sidebar_menu.html.twig";
import pager from "./templates/pager.html.twig";
import article_teaser from "./templates/article_teaser.html.twig";
import media_grid from "./templates/media_grid.html.twig";
import media_item from "./templates/media_item.html.twig";

export const sharedPartials = { sidebar_menu, pager, article_teaser, media_grid, media_item };
